const twSpecList = ["VPTWS01_1", "VPTWS02_1", "VPTWS03_1"];
const cqSpecList = ["VPCQS28_2", "VPCQS29_2", "VPCQS31_2", "VPCQS32_2"];
const twSpecFeature = {
  VPTWS01_1: ["free_game_feature"],
  VPTWS02_1: ["free_game_feature"],
  VPTWS03_1: ["resin_feature"],
};
export { twSpecList, twSpecFeature, cqSpecList };
